import { string } from 'prop-types';
import React from 'react';
import { Alert, Col, Row } from 'reactstrap';

import { productCodes } from '../../products/constants';
import { highlightedSkusShape } from '../../prop-types';
import { COLORS } from '../../utils/constants';
import FEATURE_FLAGS, { useSafeFlag } from '../../utils/flags';

function HighlightedSkusWarning({ highlightedSkus, productCode }) {
  const isCCP = productCode === productCodes.CCP;
  const isDraftCampaignEnabled = useSafeFlag(FEATURE_FLAGS.DRAFT_CAMPAIGN);
  return (
    (!highlightedSkus[productCode] ||
      highlightedSkus[productCode].length < 25) && (
      <Row key={`alert-${productCode}`}>
        <Col>
          <Alert className="px-2 py-1 font-size-small" color={COLORS.WARNING}>
            For product &quot;{productCode}&quot; we recommend adding a minimum
            of 25 SKUs{' '}
            {isCCP && !isDraftCampaignEnabled
              ? 'and no more than 5000 SKUs '
              : ''}
            in order to improve the performance of the Campaign.
          </Alert>
        </Col>
      </Row>
    )
  );
}

HighlightedSkusWarning.propTypes = {
  highlightedSkus: highlightedSkusShape.isRequired,
  productCode: string.isRequired,
};

export default HighlightedSkusWarning;
